import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "flex align-items-left justify-content-start gap-2" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mt-2 text-right" }
const _hoisted_7 = { class: "p-buttonset" }

import {inject, onMounted, ref} from 'vue'
import {useRouter} from "vue-router";
import {AxiosStatic} from "axios";
import CompanyCard from "@/components/blocks/CompanyCard.vue";
import InvoiceItems from "@/components/blocks/InvoiceItems.vue";
import {InvoiceItem} from "@/components/blocks/Types";
import Button from "primevue/button";


// Define component properties

export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceDetail',
  setup(__props) {

const router = useRouter()
const invoice = ref(null)
const items = ref<InvoiceItem[]>([])

// Define injects
const axios = inject<AxiosStatic>('axios')

// Define lifecycle hooks
onMounted(() => {
  reloadData()
})

// Define methods
function itemCreatedHandler() {
  reloadData()
}

function reloadData() {
  const invoiceNumber = router.currentRoute.value.params.number
  const url = '/invoice/detail/' + invoiceNumber
  axios?.get(url).then(response => {
    if (response.status >= 200 && response.status <= 299) {
      invoice.value = response.data
      items.value = response.data.items
    } else {
      console.error('Can not load invoice with ID ', invoiceNumber)
    }
  })
}

function downloadInvoice() {
  axios?.get('/invoice/' + invoice.value?.id + '/pdf', {
    responseType: 'blob'
  }).then(response => {

    const objectURL = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = objectURL
    link.setAttribute('download', invoice.value.number + '.pdf')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(link.href)

  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CompanyCard, {
          label: "Issuer",
          company: invoice.value?.issuerCompany
        }, null, 8, ["company"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CompanyCard, {
          label: "Recipient",
          company: invoice.value?.recipientCompany
        }, null, 8, ["company"])
      ])
    ]),
    (invoice.value != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(InvoiceItems, {
            onItemCreated: itemCreatedHandler,
            items: items.value,
            issuer: invoice.value?.issuerCompany,
            "invoice-number": invoice.value.number,
            "invoice-id": parseInt(_unref(router).currentRoute.value.params.number)
          }, null, 8, ["items", "issuer", "invoice-number", "invoice-id"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_unref(Button), {
          label: "Back",
          icon: "pi pi-backward",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }),
        _createVNode(_unref(Button), {
          label: "Download",
          icon: "pi pi-download",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadInvoice()))
        })
      ])
    ])
  ]))
}
}

})